module.exports = __webpack_public_path__ + "static/media/quickswap.072e3c37.gif";